import type { RouterConfig } from '@nuxt/schema'

const tenants = 'paribu-self|custody|paribu-stock|money|pass'
const tenantParam = `:tenant(${tenants})?`

export default {
  routes: () => [
    // Index
    {
      name: 'index',
      path: '/',
      component: () => import('@/pages/index/index.vue'),
    },

    // Dictionary
    {
      name: 'dictionary',
      path: `/:page(dictionary|sozluk)`,
      component: () => import('@/pages/dictionary/index.vue'),
    },
    {
      name: 'dictionary-detail',
      path: `/:page(dictionary|sozluk)/:detail`,
      component: () => import('@/pages/dictionary/[detail]/index.vue'),
    },

    // Announcement
    {
      name: 'announcement',
      path: `/:page(announcement|duyuru)`,
      component: () => import('@/pages/announcement/index.vue'),
    },
    {
      name: 'announcement-category',
      path: `/:page(announcement|duyuru)/:category`,
      component: () => import('@/pages/announcement/[category]/index.vue'),
    },
    {
      name: 'announcement-detail',
      path: `/:page(announcement|duyuru)/:category/:detail`,
      component: () => import('@/pages/announcement/[category]/[detail]/index.vue'),
    },

    // Status
    {
      name: 'status',
      path: `/:page(status)`,
      component: () => import('@/pages/status/index.vue'),
    },
    {
      name: 'status-detail',
      path: `/:page(status)/:detail`,
      component: () => import('@/pages/status/[detail]/index.vue'),
    },

    // Search
    {
      name: 'search',
      path: `/:page(search|arama)/:tenant(exchange|paribu-self|custody|paribu-stock|money|pass)?`,
      component: () => import('@/pages/search/index.vue'),
    },

    // Settings
    {
      name: 'settings-language-preferences',
      path: `/:page(settings/language-preferences|ayarlar/dil-secenekleri)`,
      component: () => import('@/pages/settings/language-preferences.vue'),
    },

    // Categories or Content
    {
      name: 'categories',
      path: `/:tenant(exchange|${tenants})`,
      component: () => import('@/pages/categories/index.vue'),
    },
    {
      name: 'categories-or-content',
      path: `/${tenantParam}/:category?/:detail`,
      component: () => import('@/pages/[catch-categories-or-content].vue'),
    },
  ],
} satisfies RouterConfig
